export const TIER_BENEFITS = {
  super_stockist: {
    headline: "Elite bulk pricing",
    price: "Best slab — up to 12% below list on 1,000 T+",
    perks: [
      "Priority allocation during shortages",
      "Dedicated trade-desk manager",
      "Extended 60-day credit terms",
      "First access to new mills & materials",
    ],
  },
  wholesaler: {
    headline: "Preferred wholesale rates",
    price: "Up to 8% below list on 250 T+",
    perks: [
      "Priority dispatch scheduling",
      "Assigned account executive",
      "45-day credit terms",
      "Quarterly volume rebates",
    ],
  },
  dealer: {
    headline: "Dealer pricing",
    price: "Up to 5% below list on 50 T+",
    perks: [
      "Standard dispatch SLA",
      "Quarterly volume rebates",
      "30-day credit terms",
    ],
  },
  booking_agent: {
    headline: "Agent commissions",
    price: "Earn 1.5–3% on committed volume",
    perks: [
      "Commission on every confirmed booking",
      "Live price-sheet access",
      "Client management tools",
    ],
  },
};
